// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  border-radius: 10px;
  background: var(--ion-item-background);
  margin: 16px 0;
}
ion-grid ion-row {
  border-bottom: 1px solid var(--ion-item-border-color);
  margin: 0px 16px;
}
ion-grid ion-row:last-child {
  border-bottom: 0;
}
ion-grid h5 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
ion-grid h6 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #747889;
}
ion-grid h3 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-top: 0;
}

ion-row ion-col:nth-child(2) {
  text-align: right;
}

.estimate_danger {
  color: #FF8686;
  background: transparent;
  padding: 0;
  text-align: right;
  margin: 0;
  font-size: unset;
  display: inline-block;
}

.estimate_success {
  color: #63EDBB;
  background: transparent;
  padding: 0;
  text-align: right;
  margin: 0;
  font-size: unset;
  display: inline-block;
}

.estimate_default {
  color: #acacac;
  background: transparent;
  padding: 0;
  text-align: right;
  margin: 0;
  font-size: unset;
  display: inline-block;
}

.estimate_warning {
  color: #ffc067;
  background: transparent;
  padding: 0;
  text-align: right;
  margin: 0;
  font-size: unset;
  display: inline-block;
}

.estimate_info {
  color: rgba(3, 169, 244, 0.6);
  background: transparent;
  padding: 0;
  text-align: right;
  margin: 0;
  font-size: unset;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/estimates/view/view.page.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,sCAAA;EACA,cAAA;AACJ;AACI;EACI,qDAAA;EACA,gBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAKI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAHR;;AAQI;EACI,iBAAA;AALR;;AASA;EACI,cAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AANJ;;AASA;EACI,cAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AANJ;;AASA;EACI,cAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AANJ;;AASA;EACI,cAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AANJ;;AASA;EACI,6BAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AANJ","sourcesContent":["ion-grid {\n    border-radius: 10px;\n    background: var(--ion-item-background);\n    margin: 16px 0;\n\n    ion-row {\n        border-bottom: 1px solid var(--ion-item-border-color);\n        margin: 0px 16px;\n    }\n\n    ion-row:last-child {\n        border-bottom: 0;\n    }\n\n    h5 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n    }\n\n    h6 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 16px;\n        color: #747889;\n    }\n\n    h3 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n        margin-top: 0;\n    }\n}\n\nion-row {\n    ion-col:nth-child(2) {\n        text-align: right;\n    }\n}\n\n.estimate_danger {\n    color: #FF8686;\n    background: transparent;\n    padding: 0;\n    text-align: right;\n    margin: 0;\n    font-size: unset;\n    display: inline-block;\n}\n\n.estimate_success {\n    color: #63EDBB;\n    background: transparent;\n    padding: 0;\n    text-align: right;\n    margin: 0;\n    font-size: unset;\n    display: inline-block;\n}\n\n.estimate_default {\n    color: #acacac;\n    background: transparent;\n    padding: 0;\n    text-align: right;\n    margin: 0;\n    font-size: unset;\n    display: inline-block;\n}\n\n.estimate_warning {\n    color: #ffc067;\n    background: transparent;\n    padding: 0;\n    text-align: right;\n    margin: 0;\n    font-size: unset;\n    display: inline-block;\n}\n\n.estimate_info {\n    color: rgb(3 169 244 / 60%);\n    background: transparent;\n    padding: 0;\n    text-align: right;\n    margin: 0;\n    font-size: unset;\n    display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
